module.exports = __webpack_public_path__ + "static/media/bookmark-outlined-icon.9a2f5971.svg";